module.exports = __webpack_public_path__ + "static/media/insta.f94c00ba.png";